<template>
    <h2>Страницы не существует</h2>
</template>